module.exports = {
  pie: "Pie",
  barGraphic: "BarGraphic",
  lineGraphic: "LineGraphic"
};
